module.exports = __webpack_public_path__ + "static/media/playMarketApp_v145.90fac4fe.apk";